import { group, rollup } from 'd3'

export function makeRows (viewParams, menuOptions) {
  const { allChartOfAccounts } = viewParams
  if (!allChartOfAccounts) return []

  const groupingProperty = menuOptions.optionGrouping.selectedOption()?.value || 'name'

  const chartsOfAccounts = chartOfAccountsToInclude(allChartOfAccounts, menuOptions)

  const groupedMap = rollup(chartsOfAccounts,
    function (groupValues) {
      // Indexing can break when there are missing values, example code=null might have multiple accounts for an entity
      const grouped = group(groupValues, g => g.accounting_organisation_id)

      return {
        grouping: {
          [groupingProperty]: formatGroupingText(groupValues[0][groupingProperty])
        },
        values: groupValues,
        valuesByAccountingOrganisationId: grouped,

        isGroupAccount: isGroupAccount(groupValues, viewParams),
        length: groupValues.length
      }
    },
    coa => formatGroupingText(coa[groupingProperty])
  )

  // Filter for highlights
  const highlights = menuOptions.highlights?.selectedOption()?.value

  const rows = Array.from(groupedMap.values())

  const filteredRows = rows.filter(row => {
    if (highlights === 'all') return true
    if (highlights === 'isGroupAccount') return row.isGroupAccount

    return true
  })
  return filteredRows
}

function formatGroupingText (value) {
  if (!value) return value

  // Match leading and trailing spaces and replace them with middle dots
  return value.replace(/^\s+|\s+$/g, match => '⸱'.repeat(match.length))
}

function isGroupAccount (groupValues, viewParams) {
  const { associatedChartOfAccounts } = viewParams

  const chartOfAccountIds = groupValues.map(v => v.id)

  const associatedChartOfAccount = associatedChartOfAccounts.find(function (associatedChartOfAccount) {
    return chartOfAccountIds.includes(associatedChartOfAccount.accounting_chart_of_account_id)
  })

  if (!associatedChartOfAccount) return false
  return true
}

function chartOfAccountsToInclude (chartOfAccounts, menuOptions) {
  console.log('chartOfAccountsToInclude', menuOptions)
  const filterStatement = menuOptions.filterStatement.selectedOption()?.value
  const filterGroupAccounts = menuOptions.filterGroupAccounts.selectedOption()?.value
  console.log('filterGroupAccounts', filterGroupAccounts)

  function filterFunction (coa) {
    // Never show the zenflow accounts (that would be earnings, translation reserves...)
    if (coa.is_zenflow === true) return false

    // Statement Filter
    const statementAccepted = []
    if (['both', 'pnl'].includes(filterStatement)) statementAccepted.push('pnl')
    if (['both', 'bs'].includes(filterStatement)) statementAccepted.push('bs')
    const passStatementFilter = statementAccepted.includes(coa.statement)
    if (!passStatementFilter) return false

    // Filter intercompany accounts
    if (filterGroupAccounts === 'intercompany' && !coa.isGroupAccount) return false
    if (filterGroupAccounts === 'notIntercompany' && coa.isGroupAccount) return false

    return true
  }

  return chartOfAccounts.filter(filterFunction)
}
